import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { InputContainer, InputTag, ValidationError, Placeholder } from "./styles";

const Input = ({ htmlType, name, value, handleChange, disabled, handleBlur, placeholder, hasError, errors, floatingPlaceholder, id }) => {
  const [ isShown, togglePlaceholder ] = useState(true);

  const haveValue = value && value.length;
  const inputClass = isShown && haveValue ? 'placeholder-shown' : ''
  
  return (
    <InputContainer className="input-container" hasError={hasError} disabled={disabled}>
      <InputTag
        className={inputClass}
        disabled={disabled}
        type={htmlType}
        name={name}
        id={id}
        value={value}
        onChange={handleChange}
        onBlur={(...args) => { handleBlur(...args); togglePlaceholder(true) }}
        onFocus={() => togglePlaceholder(false)}
        placeholder={placeholder}
        floatingPlaceholder={floatingPlaceholder}
      />
      {floatingPlaceholder && <Placeholder>{placeholder}</Placeholder>}
      {hasError && <ValidationError>{errors}</ValidationError>}
    </InputContainer>
  )
};

Input.propTypes = {
  htmlType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  handleBlur: PropTypes.func,
  placeholder: PropTypes.string,
  hasError: PropTypes.bool,
  errors: PropTypes.string,
  floatingPlaceholder: PropTypes.bool,
  id: PropTypes.string,
};

export default Input;
